import React from "react";

import { MyIconProps } from "@ui/Assets/MyIcons/MyIcons";

import { IconProps } from "./Icon.types";
import * as Styled from "./Icon.styled";

export const Icon: React.FC<IconProps> = ({ size, children, ...props }) => {
  const Icon = React.Children.only(children);

  return (
    <Styled.IconWrapper $size={size} {...props}>
      {React.cloneElement<MyIconProps>(Icon, {
        style: { width: "100%" },
      })}
    </Styled.IconWrapper>
  );
};
